module.exports = {
  lang: {
    banner1: '一张卡，连通全球支付场景',
    banner2: '跨境支付新势力',
    banner3: '—— GEO SWIFT CARD，重构全球付款场景',
    banner4: 'GEO SWIFT CARD，让跨境支付像本地转账一样简单',
    banner5: '请输入邮箱地址',
    banner6: '一键注册',

    pay1: '一张卡，连通全球支付场景',
    pay2: '全场景支付覆盖',
    pay3: '跨境业务 “无死角” 支持',
    pay4: '从货款支付到员工报销，跨境场景全 hold 住',
    pay5: '电商全链路：电商平台投放消费全链路，电商消费+广告投放一把抓，资金管理更高效。',
    pay6: '员工差旅 / 采购：员工海外出差刷外汇卡，自动记录消费明细，关联企业报销系统，无需垫资、无需手动贴票，财务对账 “零负担”。',



    





    cost1: '智能费用管控 —— 让每一分钱花得 “有理有据”',
    cost2: '精准控费 + 自动对账，',
    cost3: '财务效率飙升的秘密武器',
    cost4: '分级权限管理：给采购部、市场部、子公司设置不同支付限额，员工卡单笔 / 月度额度灵活调整，超限额自动预警，从源头规避支付风险。',


    secure1: '一张卡，连通全球支付场景',
    secure2: '安全合规双保险',
    secure3: '跨境支付 “稳稳的”',
    secure4: '央行合规 + 多重风控，资金安全有 “双保险”',
    secure5: '持牌运营保障：依托正规支付牌照，严格遵循国内外金融监管要求。',
    secure6: '智能风控系统：7×24 小时监测交易，对异常地区、异常金额、异常频率自动拦截，精准识别欺诈、洗钱风险，守护资金 “生命线”。',
    secure7: '应急响应机制：专属客服 + 风险专家团队，遇到支付异常 1 小时响应、4 小时给出解决方案，跨境业务不停摆。',


    speed1: '一张卡，连通全球支付场景',
    speed2: '立即开启跨境支付 “加速度”',
    speed3: '3 步开户，免费申领 GEO SWIFT CARD，',
    speed3_1: '先享 3 个月手续费 8 折！',
    speed4: '点击【立即咨询】：专属顾问 1v1 沟通，根据企业需求定制支付方案',
    speed5: '(提交资料审核：上传营业执照、法人信息，最快 1 个工作日完成开户)',
    speed6: '立即咨询',


    question1: '常见问题',
    question2: 'GEO SWIFT CARD的使用介绍',
    question3: '1、进行用户身份KYC审核，可根据您的主体类型进行实名认证：大陆企业、香港企业，新加坡企业等，审核通过后，即可开通使用权限。',
    question4: '2、开卡时选择用卡人并开卡成功，开卡前请确保资金账户余额充足。',
    question5: '卡本币是什么？',
    question6: '卡本币取决于卡片发卡国家，如果发卡国家是美国，卡本币就是美元。',
    question7: '卡片冻结后可以使用吗？',
    question8: '冻结卡片后，此卡片将不能进行正常消费，但不影响退款。',
    question9: '卡片不小心注销，是否可以申请恢复？',
    question10: '卡注销后不可恢复，请您谨慎操作。',

    chooseUs1: '选择我们',
    chooseUs2: '加速您的全球业务',
    chooseUs3: '请输入邮箱地址',
    chooseUs4: '一键注册',

    footer1: '准备好开始了吗',
    footer2: '一键注册',
    footer3: '客户建议及合作',
    footer4: '支付卡行业',
    footer5: '数据安全标准',
    footer6: '阿里云安全支持',
    footer7: '沪公网安备31011502403199号',

    contact1: '联系方式',
  }
}